<template>
    <div class="page-bg">
      <div class="title-box" @click="goSearch">
        <search-head :isDisabled="true"></search-head>
      </div>
      <div class="sidebar-box">
        <van-sidebar class="vant-sidebar-box" v-model="activeKey" @change="sideChange">
          <van-sidebar-item v-for="item in mainCategoryList" :key="item.id" class="vant-sidebar-item" :title="item.name" />
        </van-sidebar>
      </div>
      <div class="content-box">
        <category-goods :childCategoryList="childCategoryList"></category-goods>
      </div>
    </div>
</template>

<script>
  import searchHead from './components/searchHead'
  import CategoryGoods from './components/categoryGoods'
  import axios from 'axios'
  import apiConfig from '@/api'
    export default {
      name: 'retail-category',
      props: {
      },
      data () {
        return {
          activeKey: 0,
          mainCategoryList: [],
          childCategoryList: [],
        }
      },
      components:{
        searchHead,
        CategoryGoods
      },
      created(){
        this.getMainCategory();
      },
      methods:{
        goSearch() {
          this.$router.push({
            name: 'retail-search',
            query: {},
          });
        },
        sideChange(val) {
          this.childCategoryList = this.mainCategoryList[val].children;
        },
        getMainCategory() {
          const url = apiConfig.serverAddress + apiConfig.mainCategories;
          const restParams = {}
          const headers = {
            'Content-Type': "application/json",
          }
          axios  //axios请求体BODY上为model
          .post(url, {'restParams':restParams, headParams: {userKey: ""}}, { headers: headers })
          .then(response => {
            this.mainCategoryList = response.data.data;
            this.childCategoryList = this.mainCategoryList.length > 0 ? this.mainCategoryList[0].children : [];
          });
        }
      }
    }
</script>


<style scoped>
  .page-bg {
    background: #FFFFFF;
    height: 100%;
  }
  .title-box {
    background: #FFFFFF;
    position: fixed;
    width: 100%;
    height: 100px;
    z-index: 2;
  }
  .sidebar-box {
    margin-top: 100px;
    width: 200px;
    height: 100%;
    background: #F7F8FA;
    position: absolute;
    overflow-y: auto;
  }
  .vant-sidebar-box {
    width: 100%;
  }
  .vant-sidebar-item {
     line-height: 50px;
     font-size: 30px;
     text-align: center;
  }
  .content-box {
    margin-top: 100px;
    width: calc(100% - 200px);
    height: calc(100% - 100px);
    float: right;
    overflow-y: auto;
  }
</style>




// WEBPACK FOOTER //
// src/pages/retail/category.vue